
import React from 'react'
import MessageChatAuthor from '../../components/massageChatAuthor/MessageChatAuthor'

const MessagesAuthor = () => {
  return (
   
    <div className='dashboard-content-box massage-sec'>
      <MessageChatAuthor />
    </div>
  )
}

export default MessagesAuthor

